import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeRestoreFailedAction = {
	type: 'SUBJECT_TYPE_RESTORE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeRestoreFailedAction => ({
	type: 'SUBJECT_TYPE_RESTORE_FAILED',
	payload,
});
